// extracted by mini-css-extract-plugin
export default {"header":"Header_header__d+igc","headerLogo":"Header_headerLogo__1SOtr"};